import moment from 'moment'
import { useEffect, useRef } from 'react'
import { PROJECT_CODE } from '../constants/roles'

export const deepCopyObject = (obj = {}) => JSON.parse(JSON.stringify(obj))

export const parseJson = (str, defaultValue = null) => {
  try {
    return JSON.parse(str)
  } catch (e) {
    return defaultValue
  }
}

export function generateUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const getDiffDays = date => {
  const oneDay = 24 * 60 * 60 * 1000
  const firstDate = new Date()
  const secondDate = new Date(date)

  return Math.round(Math.abs((firstDate - secondDate) / oneDay))
}

export const getDiffTime = date => {
  if (date) {
    const now = moment(new Date())
    const then = moment(new Date(date))
    const ms = now.diff(then)
    return AddSecToMs(ms, 0)
  }
  return {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    ms: 0
  }
}
export const getValidDate = (date, hasHours = false) => {
  if (!date) return '-'

  if (hasHours) {
    return moment.utc(date).format('HH:mm:ss, DD.MM.YYYY')
  } else {
    return moment.utc(date).format('DD.MM.YYYY')
  }
}

export const AddSecToMs = (ms, sec = 1) => {
  const newMs = ms + sec * 1000
  const hours = moment.duration(newMs).hours()
  const minutes = moment.duration(newMs).minutes()
  const seconds = moment.duration(newMs).seconds()
  const days = Math.floor(moment.duration(newMs).asDays())
  return {
    days,
    hours,
    minutes,
    seconds,
    ms: newMs
  }
}

export const toTargetObj = (name, value) => ({ target: { name, value } })

export const toDate = dateStr => {
  if (dateStr) {
    const [day, month, year] = dateStr?.split('.')
    return new Date(year, month - 1, day) || null
  }
  return null
}

export const hasRole = (roles = [], user = {}, key = 'roles') => {
  if (!user || !user?.[key] || !Array.isArray(roles) || !key) {
    return false
  }

  return user?.[key]?.some(e => roles.includes(e?.code) && e?.project?.code === PROJECT_CODE)
}

export const hasRoleByCode = (role = '', user = {}, key = 'roles') => {
  if (!user || !user?.[key] || !role) {
    return false
  }

  return !!user?.[key]?.some(({ code, project }) => code === role && project?.code === PROJECT_CODE)
}

export const sleep = async (timeout = 1000) => {
  await new Promise(resolve => setTimeout(resolve, timeout))
}

export const hasRoleById = (projectCode = '', role = '', user = {}, key = 'roles') => {
  if (!user || !user?.[key] || !projectCode || !role) {
    return false
  }
  return user[key].some(item => item.code === role && item.project?.code === projectCode)
}

export const hasRoleByPosition = (role = '', user = {}, position, key = 'roles') => {
  if (!user || !user?.[key] || !role) {
    return false
  }

  const hasRoleInProject = user[key]?.some(({ code, project }) => code === role && project?.code === PROJECT_CODE)
  const hasSoftPosition = user?.userType?.includes(position)

  return hasRoleInProject && hasSoftPosition
}

export const getFomattedDate = date => {
  if (moment(date).format('DD.MM.YYYY') === 'Invalid date') return date

  return moment(date).format('DD.MM.YYYY')
}

export const getFomattedDateWithTime = date => {
  if (date == null) return date
  const m = moment(date)
  if (!m.isValid()) return date
  return m.format('DD.MM.YYYY')
}

export const getFormattedFiltersDate = date => {
  if (moment(date).format('DD.MM.YYYY') === 'Invalid date') return date

  return moment(date).format('HH:mm:ss, DD.MM.YYYY')
}

export const getCurrentDay = () => {
  const date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth() + 1 <= 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  const day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()

  return [year, month, day].join('-')
}

export const smartEnds = (n, w, o, s, m, full) => {
  if ((!!w || w === '') && (!!o || o === '') && (!!s || s === '') && (!!m || m === '') && (!!n || n === 0)) {
    n = n.toString()
    if ((n.length === 1 || n > 20) && n[n.length - 1] === '1') return n + (full ? '' : w) + o
    if ((n.length === 1 || n > 20) && n[n.length - 1] < 5 && n[n.length - 1] > 1) return n + (full ? '' : w) + s
    if (n[n.length - 1] > 4 || n[n.length - 1] === '0' || (n > 4 && n < 21)) return n + (full ? '' : w) + m
  } else {
    return n + w
  }
}

export const dateDiff = diff => {
  if (!diff) {
    return diff
  }
  const times = {
    ss: !!parseInt(moment(diff).utc().format('ss'))
      ? smartEnds(parseInt(moment(diff).utc().format('ss')), ' секунд', 'а', 'ы', '')
      : '',
    mm: !!parseInt(moment(diff).utc().format('mm'))
      ? smartEnds(parseInt(moment(diff).utc().format('mm')), ' минут', 'а', 'ы', '') + ' '
      : '',
    HH: !!parseInt(moment(diff).utc().format('HH'))
      ? smartEnds(parseInt(moment(diff).utc().format('HH')), ' час', '', 'а', 'ов') + ' '
      : '',
    DD: !!(parseInt(moment(diff).utc().format('DD')) - 1)
      ? smartEnds(parseInt(moment(diff).utc().format('DD')) - 1, ' день', ' день', ' дня', 'дней', true) + ' '
      : '',
    MM: !!(parseInt(moment(diff).utc().format('MM')) - 1)
      ? smartEnds(parseInt(moment(diff).utc().format('MM')) - 1, ' месяц', '', 'а', 'ев') + ' '
      : ''
  }
  if (diff < 60000) {
    return times.ss || ''
  }
  if (diff < 3600000) {
    return (times.mm || '') + (times.ss || '')
  }
  if (diff < 86400000) {
    return (times.HH || '') + (times.mm || '')
  }
  if (!(parseInt(moment(diff).utc().format('MM')) - 1)) {
    return (times.DD || '') + (times.HH || '') + (times.mm || '')
  }
  return (times.MM || '') + (times.DD || '') + (times.HH || '') + (times.mm || '')
}

export const deepCopyArrayOfObjects = arr => {
  const newArray = []

  arr.forEach(obj => {
    const newObj = Object.assign({}, obj)
    newArray.push(newObj)
  })

  return newArray
}

const noop = () => {}

export const useInterval = (callback, delay, immediate) => {
  const savedCallback = useRef(noop)

  useEffect(() => {
    savedCallback.current = callback
  })

  useEffect(() => {
    if (!immediate || delay === null || delay === false) return
    savedCallback.current()
  }, [immediate])

  useEffect(() => {
    if (delay === null || delay === false) return
    const tick = () => savedCallback.current()
    const id = setInterval(tick, delay)
    return () => clearInterval(id)
  }, [delay])
}

export const sortByName = arr => {
  return arr.sort((a, b) => {
    const nameA = a.toUpperCase()
    const nameB = b.toUpperCase()
    if (nameA < nameB) {
      return -1
    }
    if (nameA > nameB) {
      return 1
    }

    return 0
  })
}

export const flatDeep = (arr, d = 1) =>
  d > 0 ? arr.reduce((acc, val) => acc.concat(Array.isArray(val) ? flatDeep(val, d - 1) : val), []) : arr.slice()

export const toBase64 = async file =>
  await new Promise((resolve, reject) => {
    try {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = reject
    } catch (e) {
      resolve(null)
    }
  })

export const toNumber = str => {
  const regex = /[\D\s]/g
  return Number(str.replace(regex, ''))
}

export const statusTrackDateToNormal = dateStr => {
  if (!dateStr) {
    return new Date().toJSON()
  }

  const [datePart, timePart] = dateStr.split('T')

  const [day, month, year] = datePart.split('.')
  const [hours, minutes] = timePart.split(':')

  const dayNum = parseInt(day, 10)
  const monthNum = parseInt(month, 10) - 1
  const yearNum = parseInt(year, 10)
  const hoursNum = parseInt(hours, 10)
  const minutesNum = parseInt(minutes, 10)

  return new Date(yearNum, monthNum, dayNum, hoursNum, minutesNum).toJSON()
}

export const hidePhoneNumber = (str, index = 4) => (str?.length ? str?.toString()?.replaceAt(index, '***') : str)

export const isValidDate = dateStr => !!new Date(dateStr).getDate()

export const getFullName = (firstName, lastName, patronymic, titleName) => {
  if (!firstName && !lastName && !patronymic && !titleName) {
    return '-'
  }
  return [firstName, lastName, patronymic, titleName].filter(Boolean).join(' ')
}

export const getDaysLabel = days => {
  if (days === 1) {
    return 'день'
  } else if (days >= 2 && days <= 4) {
    return 'дня'
  } else {
    return 'дней'
  }
}

export const sortByOverdueDays = (a, b) => (b.overdueDays || 0) - (a.overdueDays || 0)

export const getFirstDayOfMonth = () => {
  const date = new Date()
  return new Date(date.getFullYear(), date.getMonth(), 1)
}

export const toUtcMidnightIso = d =>
  new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0)).toISOString()



export const toISODate = d => {
  if (!(d instanceof Date) || isNaN(d)) return ''
  const pad = n => (n < 10 ? '0' + n : '' + n)
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

export const ymdToDate = ymd => {
  if (!ymd || typeof ymd !== 'string') return null
  const [y, m, d] = ymd.split('-').map(Number)
  if (!y || !m || !d) return null
  return new Date(y, m - 1, d, 0, 0, 0, 0)
}

export const dateToYMD = date => {
  if (!(date instanceof Date) || isNaN(date)) return ''
  const pad = n => (n < 10 ? '0' + n : '' + n)
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

export const diffDaysRange = (fromStr, toStr) => {
  if (!fromStr || !toStr) return 0
  const from = ymdToDate(fromStr)
  const to = ymdToDate(toStr)
  if (!from || !to) return 0
  return Math.round((to - from) / (1000 * 60 * 60 * 24)) + 1
}

export const isFutureDate = dateStr => {
  if (!dateStr) return false
  const picked = ymdToDate(dateStr)
  if (!picked) return false
  const now = new Date()
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
  return picked > today
}

export const formatHumanDateRange = (from, to) => {
  if (!from || !to) return 'Выберите диапазон дат'
  const days = diffDaysRange(from, to)
  return `${from} — ${to} (${days} дн.)`
}

export const toUtcStartOfDayIsoFromYMD = dateStr => {
  const d = ymdToDate(dateStr)
  if (!d) return null
  return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0)).toISOString()
}
export const toUtcEndOfDayIsoFromYMD = dateStr => {
  const d = ymdToDate(dateStr)
  if (!d) return null
  return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999)).toISOString()
}


export const buildExportParams = (from, to, status = '') => ({
  from: toUtcStartOfDayIsoFromYMD(from),
  to: toUtcEndOfDayIsoFromYMD(to),
  status: status || ''
})
